var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProcessInvokeModelInstanceIcon = function SvgProcessInvokeModelInstanceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#595959",
    viewBox: "-450 -450 2000 2000",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1170.286 877.714v73.143H0V73.143h73.143v804.571zm-73.143-713.143v248.571q0 12-11.143 16.857t-20.286-4.286l-69.143-69.143-361.714 361.714q-5.714 5.714-13.143 5.714t-13.143-5.714L475.428 585.141 237.714 822.855 128 713.141l334.286-334.286q5.714-5.714 13.143-5.714t13.143 5.714l133.143 133.143 265.143-265.143-69.143-69.143q-9.143-9.143-4.286-20.286t16.857-11.143h248.571q8 0 13.143 5.143t5.143 13.143z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgProcessInvokeModelInstanceIcon);
export default Memo;